import React, { useState } from 'react';
import ShareIcon from './ShareIcon';
import '../styles/NewsItem.scss';

interface NewsItemProps {
  id: string;
  title: string;
  date: string;
  summary: string;
  image: string;
  sourceUrl: string;
  slug: string;
}

const NewsItem: React.FC<NewsItemProps> = ({ id, title, date, summary, image, sourceUrl, slug }) => {
  const [showImage, setShowImage] = useState(true);

  // Quando a imagem for carregada, se sua largura for menor que 500px, ela não será exibida.
  const handleImageLoad = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const img = e.currentTarget;
    if (img.naturalWidth < 500) {
      setShowImage(false);
    }
  };

  const shareLink = `https://resumiprati.com.br/news/${slug}`;

  return (
    <div className="news-item">
      <ShareIcon shareUrl={shareLink} title={title} />

      {showImage && image && (
        <img
          src={image}
          alt={title}
          className="news-item__image"
          onLoad={handleImageLoad}
        />
      )}

      <div className="news-item__content">
        <h2 className="news-item__title">{title}</h2>
        <p className="news-item__date">{date}</p>
        <p className="news-item__summary">{summary}</p>
        <div className="news-item__actions">
          <a
            href={sourceUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="news-item__source"
            aria-label="Ver notícia original"
          >
            Fonte da notícia
          </a>
        </div>
      </div>
    </div>
  );
};

export default NewsItem;
